angular.module('account').controller('ForgotPasswordCtrl',
    ['$scope', '$stateParams', 'toaster', 'aprgettext', 'TransitionManager', 'SessionService', 'AccountRepository', 'LocalStorageRepository',
        function ($scope, $stateParams, toaster, gettext, TransitionManager, SessionService, AccountRepository, LocalStorageRepository) {
            'use strict';

            $scope.loading = false;
            $scope.model = {
                UserName: LocalStorageRepository.getUserName(),
                ClientId: LocalStorageRepository.getClientID(),
                NewPassword: '',
                Questions: []
            };
            $scope.Answers = {
                Question1: '',
                Question2: '',
                Question3: ''
            };
            $scope.confirmNewPassword = '';

            $scope.back = back;
            $scope.submit = submit;

            loadSecurityQuestions();
            function loadSecurityQuestions() {
                $scope.loading = true;
                $scope.removeHttpError();

                AccountRepository.getSecurityQuestions($scope.model.UserName, $scope.model.ClientId)
                    .then(function (data) {
                        if (data) {
                            var securityQuestions = data.plain();
                            $scope.model.Questions = securityQuestions.Questions;
                        }else{
                            toaster.pop('warning', '', gettext('You do not have Security Questions configured. Please contact the practice.'));
                            back();
                        }
                    }).catch(function (response) {
                        toaster.pop('warning', '', gettext('You do not have Security Questions configured. Please contact the practice.'));
                        $scope.addHttpError(response);
                    }).finally(function () {
                        $scope.loading = false;
                    });
            }

            function back() {
                SessionService.setDisplayDashboardToolbar(false);
                TransitionManager.transition({appRoute: 'login'});
            }

            function submit() {

                if ($scope.changePasswordForm.$invalid) {
                    return;
                }

                $scope.loading = true;
                var requestDto = {
                    UserName: $scope.model.UserName,
                    ClientId: $scope.model.ClientId,
                    NewPassword: $scope.model.NewPassword,
                    Questions: _($scope.model.Questions)
                        .map(function (question) {
                            return {
                                Id: question.Id,
                                Text: question.Text,
                                Answer: '',
                                DisplayOrder: question.DisplayOrder
                            };
                        }).value()
                };

                if (requestDto.Questions.length === 3) {
                    requestDto.Questions[0].Answer = $scope.Answers.Question1;
                    requestDto.Questions[1].Answer = $scope.Answers.Question2;
                    requestDto.Questions[2].Answer = $scope.Answers.Question3;
                }

                AccountRepository.postForgotPassword(requestDto)
                    .then(function (data) {
                        console.log(data);
                        toaster.pop('success', '', gettext('Password has been changed successfully. Please login with new password.'));
                        TransitionManager.transition({appRoute: 'login'});
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('One or more answers were incorrect. Please try again or contact your practice for further assistance.'));
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }
        }]);


